import { CheckContractor } from "winslow-core";
import { Alert, AlertDescription } from "../../../ds2/components/Alert";
import { Button } from "../../../ds2/components";
import toast from "react-hot-toast";
import { toastFail } from "../../../config";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import { getCurrentCheckCompanyId } from "winslow-core";

type AppCheckContractorStatusProps = {
    checkContractor: CheckContractor | undefined | null;
    allowCreate: boolean;
    hasBasics: boolean; // true if ssn_last_four or ein is provided
    handleCreateContractor?: () => void;
    onViewOnboarding?: () => void;

    // handleLaunchCheckOnboarding: () => void;
    // handleLaunchCheckImplementation: () => void;
}

export const AppCheckContractorStatus = ({ 
    checkContractor,
    allowCreate,
    hasBasics,
    handleCreateContractor,
    onViewOnboarding,
    // handleLaunchCheckOnboarding,
    // handleLaunchCheckImplementation
}: AppCheckContractorStatusProps) => {
    const storeUser = useSelector(selectUser);
    const checkCompanyId = getCurrentCheckCompanyId(storeUser);

    return (
        <>
            {/* basics not done yet */}
            {checkContractor && !hasBasics && 
                <Alert variant="destructive" className="app-pay-configuration-alert">
                    <AlertDescription>
                        Please supply the required information to enroll in payroll.
                    </AlertDescription>
                </Alert>
            }

            {/* basics in place but not completed */}
            {checkContractor && hasBasics && checkContractor.onboard?.status !== "completed" && 
                <Alert variant="destructive" className="app-pay-configuration-alert">
                    <AlertDescription>
                        Contractor onboarding is not completed. Current status: <strong>{checkContractor.onboard?.status || "unknown"}</strong>. 
                        You cannot save changes until onboarding is completed.
                    </AlertDescription>
                    <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                        {onViewOnboarding && (
                            <Button
                                label="View"
                                variant="secondary"
                                onClick={onViewOnboarding}
                            />
                        )}
                        <Button
                            label="Resolve"
                            variant="secondary"
                            // onClick={handleLaunchCheckOnboarding}
                        />
                    </div>
                </Alert>
            }
            {!checkContractor && allowCreate && checkCompanyId &&
                <Alert variant="warning" className="app-pay-configuration-alert">
                    <AlertDescription>
                        Create payroll contractor record.
                        <Button
                            label="Create"
                            variant="secondary"
                            onClick={handleCreateContractor}
                        />
                    </AlertDescription>
                </Alert>
            }
            {!checkContractor && allowCreate && !checkCompanyId &&
                <Alert variant="warning" className="app-pay-configuration-alert">
                    <AlertDescription>
                        To enroll contractors and vendors in payroll, please enroll your company first.
                    </AlertDescription>
                </Alert>
            }
        </>
    )
}

